/**
 * Common icon button sizes.
 * Used to size the button and icon.
 */

/**
 * Per Figma:
 * https://www.figma.com/file/ppvpPegXOdvLLpuHxOiIRn/Donor-facing-pages-UI-kit?node-id=7302%3A9882&mode=dev
 */
export const ICON_BUTTON_SIZE_PRESETS = {
  md: {
    width: '48px',
    height: '48px',
    padding: '11px',
    borderRadius: 'var(--classy-border__radius-md)'
  },
  sm: {
    width: '40px',
    height: '40px',
    padding: '7px',
    borderRadius: 'var(--classy-border__radius-md)'
  },
  xs: {
    width: '24px',
    height: '24px',
    padding: '4px',
    borderRadius: 'var(--classy-border__radius-sm)'
  }
};

/**
 * Per Figma:
 * https://www.figma.com/file/ppvpPegXOdvLLpuHxOiIRn/Donor-facing-pages-UI-kit?node-id=7479%3A67909&mode=dev
 */
export const SVG_ICON_SIZE_PRESETS = {
  md: {
    height: '24px',
    width: '24px'
  },
  sm: {
    height: '24px',
    width: '24px'
  },
  xs: {
    height: '16px',
    width: '16px'
  }
};